import type { ActivityModule } from '../../core/activity';
import { mountMoneyBack } from './ui';
import levelsData from './levels.json';
import '../money/style.css';
import './style.css';

export const moneyBack: ActivityModule = {
  id: 'money_back',
  title: 'Devolva o troco',
  description: 'O cliente paga e você precisa montar o troco com as moedas e notas certas.',
  ageMin: 7,
  ageMax: 11,
  difficulty: 3,
  iconPath: 'assets/gcompris-AGPL/money_back/icon.svg',
  category: 'aritmetica',
  totalLevels: levelsData.levels.length,
  mount: mountMoneyBack,
};
